import { useCallback, useMemo } from "react";

import { Country, useCountries } from "../services";
import { PickerInput } from "../lib";

type Props = {
  onChange: (country: Country) => void;
  placeholder?: string;
  value: number | null;
  variant?: "default" | "phone";
};

export function CountryInput({
  onChange,
  placeholder = "Select country",
  value,
  variant = "default",
}: Props) {
  // Data
  const { data: countries } = useCountries();

  // Vars
  const countryOptions = useMemo(() => {
    return (countries ?? []).map(({ id, name, calling_code: callingCode }) => ({
      label: variant === "phone" ? `${name} (+${callingCode})` : name,
      value: id,
    }));
  }, [countries, variant]);

  const country = useMemo(() => {
    return countries?.find(({ id }) => id === value) ?? null;
  }, [countries, value]);

  // Handlers
  const handleChange = useCallback(
    (_name: "country_id", id: number | null) => {
      // TOFIX: id is received as string from Picker...
      const country =
        id && countries
          ? countries.find((country) => country.id === Number(id))
          : null;

      if (country) {
        onChange(country);
      }
    },
    [countries, onChange]
  );

  // Render
  return (
    <PickerInput
      disabled={!countries}
      name="country_id"
      value={country?.id ?? null}
      onChange={handleChange}
      options={countryOptions}
      placeholder={!countries ? "Loading..." : placeholder}
    />
  );
}
